import React from "react";
import moment from "moment";
import { TAnnex6V2Record } from "redux/app/annex6-v2/@types";
import { TAnnex6V2GroupM1 } from "redux/app/annex6-v2/groups/group-m";
import Annex6V2TableRows from "../Annex6V2TableRows";

type OwnProps = {
	annex6V2Record: TAnnex6V2Record;
	isStrikedOff?: boolean;
	theme?: "light" | "dark";
};
type Annex6V2GroupM1PreviewProps = OwnProps;

function Annex6V2GroupM1Preview(props: Annex6V2GroupM1PreviewProps) {
	const record = props.annex6V2Record as TAnnex6V2GroupM1;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		const tableRows = [[operationDate, "M", "-", renderItemM1()]];

		return (
			<Annex6V2TableRows
				record={record}
				tableRows={tableRows}
				theme={props.theme}
			/>
		);
	}

	function renderItemM1() {
		return <h4 className="font-medium uppercase">{record.remarks}</h4>;
	}

	return renderMain();
}

export default Annex6V2GroupM1Preview;
